<template>
  <div class="app-container">
    <SearchBar />
    <el-table
      v-loading="listLoading"
      :data="tableList"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      height="750"
    >
      <el-table-column align="center" width="40">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column width="80" align="center">
        <template slot-scope="scope">
          <el-checkbox-group v-model="checkList" @change="onCheck(scope.row)">
            <!-- 加个空格不显示文字 -->
            <el-checkbox :label="scope.row.areaId">&nbsp;</el-checkbox>
          </el-checkbox-group>
        </template>
      </el-table-column>

      <!-- <el-table-column label="编码"  align="center">
        <template slot-scope="scope">
          {{ scope.row.areaCode }}
        </template>
      </el-table-column> -->

      <el-table-column label="名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.areaName }}</span>
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="拼音"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.pinyin }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="是否热门" align="center">
        <template slot-scope="scope">
          {{ scope.row.isHot ? '是' : '否' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="是否城市" align="center">
        <template slot-scope="scope">
          {{ scope.row.isArea ? '是' : '否' }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="经度"  align="center">
        <template slot-scope="scope">
          {{ scope.row.lng }}
        </template>
      </el-table-column>

        <el-table-column class-name="status-col" label="纬度" align="center">
        <template slot-scope="scope">
          {{ scope.row.lat }}
        </template>
      </el-table-column> -->

      <!-- <el-table-column class-name="status-col" label="添加人" align="center">
        <template slot-scope="scope">
          {{ scope.row.createBy || ''}}
        </template>
      </el-table-column> -->
      <!-- <el-table-column class-name="status-col" label="添加时间" width="160" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column class-name="status-col" label="修改人" align="center">
        <template slot-scope="scope">
          {{ scope.row.updateBy || '' }}
        </template>
      </el-table-column> -->
      <el-table-column
        v-if="tableList[0] && tableList[0].level == 2"
        label="排序"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.sortIndex }}</div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="onEdit(scope.row)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="onSort(scope.row)"
            v-if="
              roleList[path].includes('_Update') &&
              tableList[0] &&
              tableList[0].level == 2
            "
            >排序</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <!-- 修改表单对话框 -->
    <editCity ref="editCity" />
    <!-- 添加表单对话框 -->
    <addCity ref="addCity" />
    <!-- 修改排序 -->
    <editSort @handleFresh="getAreaAllData" ref="editSort" />
  </div>
</template>

<script>
// import { getList } from '@/api/table'
import Pagination from '@/components/Pagination';
import SearchBar from './searchBar';
const editCity = () => import('./editCity');
const addCity = () => import('./addCity');
const editSort = () => import('./editSort.vue');
import { mapGetters } from 'vuex';
import { getAreaList, getOneObjApi } from '@/api/areaApi';

export default {
  name: 'CityAppMain',
  components: {
    SearchBar,
    Pagination,
    editCity,
    addCity,
    editSort,
  },
  data() {
    return {
      tableList: [],
      listLoading: false,
      checkList: [],
      pageIndex: '',
      pageSize: '',
      path: '',
    };
  },
  computed: {
    ...mapGetters(['checkNodeData', 'checkAreaListID', 'paginObj', 'roleList']),
  },
  watch: {
    checkNodeData() {
      // 如果length为0，说明用户点击的节点是没有子节点的，就请求单个对象数据
      // 大于0，则表示用户点击的有下
      return this.checkNodeData.childNodes.length > 0
        ? this.getAreaAllData()
        : this.getAreaOneData();
    },
    checkAreaListID(data) {
      this.checkList = data;
    },
    paginObj: 'getAreaAllData',
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 请求表单数据
    async getAreaAllData() {
      try {
        this.listLoading = true;
        let res = await getAreaList({
          pAreaId: this.checkNodeData.data.areaId,
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
        });
        this.listLoading = false;
        let { dataList, totalCount, pageSize, pageIndex } = res.data.pageResult;
        this.tableList = dataList;
        // console.log('tableList', this.tableList);
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
        this.$refs.Pagination.totalCount = totalCount;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
      } catch (e) {
        window.console.log(e);
      }
    },

    // 点击tree节点时获取单个对象数据
    async getAreaOneData() {
      try {
        let res = await getOneObjApi(this.checkNodeData.data.areaId);
        let list = [];
        list.push(res.data.model);
        this.tableList = list;
      } catch (e) {
        window.console.log(e);
      }
    },

    onEdit(col) {
      this.$refs.editCity.editForm = col;
      this.$refs.editCity.dialogFormVisible = true;
    },

    // 排序
    onSort(row) {
      let { areaId, sortIndex } = row;
      this.$refs.editSort.editForm.areaId = areaId;
      this.$refs.editSort.editForm.sortIndex = sortIndex;
      this.$refs.editSort.dialogFormVisible = true;
      // console.log(row);
    },

    // 点击单选框时
    onCheck(row) {
      this.$refs.editCity.editForm = row;
      this.$store.dispatch('area/setCheckAreaListID', this.checkList);
    },
  },
};
</script>

<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}
</style>
